import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const msnInArticle150100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'msan_150x100',
  className: 'msan_150x100',
  aspectRatio: 1.50,
  type: 'Image150x100',
  associationType: 'ImageMedia15X10',
  imagePreviewHeight: 200,
  minimumRequirements: 0,
  minSize: [300, 200],
  localizedText: {
    previewTypeStringKey: _TL_('MSN in-article ad'),
    stringKey: _TL_('1.5:1'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showShortHeadline: true,
    showDescription: true,
    showShortHeadlineMultiline: true,
    showAdditionalDisclaimer: true,
    showMultipleDescription: true,
    showUrlMultiline: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    businessNameWithAds: {
      padding: '1px 0',
      marginTop: 9,
      '& .adslabel': {
        border: '.5px solid #78718a',
        color: '#78718a',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '13.64px',
        textDecorationThickness: 'auto',
        textSizeAdjust: '100%',
        borderRadius: '4px',
        background: '#fff',
        padding: '.8px 4px',
        margin: '0 5px 0 0',
      },
      '& .business-name': {
        color: '#333',
        fontSize: 11,
        lineHeight: '15.004px',
        padding: '1px 0',
      },
    },
    description: {
      height: 45,
      margin: '5px 0 10px 0',
      fontSize: 14,
      maxWidth: 250,
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
    },
    shortHeadline: {
      fontSize: 15,
      lineHeight: '1.2',
      height: 60,
      position: 'relative',
      top: -6,
      color: '#207697',
      fontWeight: 200,
      paddingBottom: 5,
    },
    textContainer: {
      padding: '10px',
      color: '#333',
    },
  },
};

export default msnInArticle150100Raw;
